import { getTheme } from "@fluentui/react";

import { AccountCell } from "./cells/accountCell";
import { InfosCell } from "./cells/infosCell";
import { NextStepCell } from "./cells/nextStepCell";
import { ShipmentCell } from "./cells/shipmentCell";

import { CopyPaste } from "@/components/CopyPaste";
import { TranslatedContractOrigin } from "@/modules/Contracts/enums";
import { ContractItem } from "@/modules/Contracts/types";

interface ContractColumnsProps {
  listItems?: ContractItem[];
  canRead: boolean;
  canListShipments: boolean;
}

export function ContractColumns({
  listItems,
  canRead,
  canListShipments
}: ContractColumnsProps) {
  const theme = getTheme();
  const idsToCopy = (listItems ?? []).map(item => item.id).join("\n");
  let isInProgress = false;

  const columns = [
    {
      key: "id",
      name: "Código",
      minWidth: 90,
      maxWidth: 90,
      fieldName: "id",
      isRowHeader: true,
      data: "string",
      onRenderHeader: () => (
        <CopyPaste
          valueToCopy={idsToCopy}
          tooltipText="Copiar códigos desta página"
          iconSize={12}
          iconColor={theme.palette.themeSecondary}
          iconPosition="before"
        >
          Código
        </CopyPaste>
      )
    },
    {
      key: "account",
      name: "Cooperado",
      minWidth: 200,
      fieldName: "account",
      isRowHeader: true,
      data: "string",
      isPadded: true,
      isMultiline: true,
      onRender: item => {
        isInProgress = item.currentStep?.internalName === "IN_PROGRESS";

        return (
          <AccountCell
            canRead={canRead}
            item={item}
            isInProgress={isInProgress}
          />
        );
      }
    },
    {
      key: "origin",
      name: "Origem",
      fieldName: "origin",
      isRowHeader: true,
      minWidth: 140,
      maxWidth: 140,
      data: "string",
      onRender: (item: ContractItem) => {
        return <div>{TranslatedContractOrigin[item.origin]}</div>;
      }
    },
    ...(canListShipments
      ? [
          {
            key: "shipment",
            name: "Código do Envio",
            fieldName: "contractShipments",
            minWidth: 240,
            maxWidth: 240,
            isMultiline: true,
            onRender: (item: ContractItem) => <ShipmentCell item={item} />
          }
        ]
      : []),
    {
      key: "items",
      name: "Itens",
      minWidth: 50,
      maxWidth: 50,
      fieldName: "items",
      isRowHeader: true
    },
    {
      key: "nextStep",
      name: "Estado",
      minWidth: 160,
      maxWidth: 160,
      fieldName: "nextStep",
      isRowHeader: true,
      isPadded: true,
      isMultiline: true,
      onRender: item => {
        return <NextStepCell item={item}></NextStepCell>;
      }
    },
    {
      key: "infos",
      name: "Informações",
      minWidth: 200,
      maxWidth: 200,
      fieldName: "infos",
      isRowHeader: true,
      isMultiline: true,
      onRender: item => {
        return <InfosCell item={item} />;
      }
    },
    {
      key: "createdAt",
      name: "Data",
      fieldName: "createdAt",
      isRowHeader: true,
      minWidth: 100,
      data: "string",
      onRender: ({ createdAt }) => {
        if (createdAt) {
          return (
            <div>
              {new Intl.DateTimeFormat("pt-BR").format(new Date(createdAt))}
            </div>
          );
        }
      }
    }
  ];

  return columns;
}
